import { type FC } from "react";
import { type ContactableTimeRangeCassetteProps } from "@legacy_user_frontend/components/pages/mypage/profiles/profiles_show/src/profile_show_props";
import * as styles from "../styles.css";

export const ContactableTimeRangeCassette: FC<ContactableTimeRangeCassetteProps> = ({
  contactableTimeRange: { contactableTimeRanges, contactableTimeRangesNote },
}) => (
  <div className={styles.tableList}>
    {contactableTimeRanges.length > 0 && (
      <>
        <dt>連絡可能時間帯</dt>
        <dd>
          <ul className={styles.list}>
            {contactableTimeRanges.map(({ label }) => (
              <li key={label}>{label}</li>
            ))}
          </ul>
        </dd>
      </>
    )}
    {contactableTimeRangesNote && (
      <>
        <dt>備考</dt>
        <dd>{contactableTimeRangesNote}</dd>
      </>
    )}
  </div>
);
